const r=(e,t)=>e==="right"?"rtl":e==="left"?"ltr":t&&t==="rtl"?t:"ltr";export{r as getDirectionFromAlignmentAndTextDirection};
//# sourceMappingURL=textDirection.js.map
